import React from "react";

function Navbar({ toggleSidebar }) {
  return (
    <nav className="navbar">

      {/* <h4 className="navbar-title">Premiumcarrentals</h4> */}
      <img style={{height:"70px"}} src="https://i.ibb.co/mGh4f8g/Premium-Car-Rentals-Limited-Logo-Design-1-removebg-preview.png"/>
      <button onClick={toggleSidebar} className="toggle-button me-4">
        ☰
      </button>
    </nav>
  );
}

export default Navbar;

